import { el } from 'redom';

class ActivityNotExistsView {

  constructor() {

    this.el = el('#activity-not-exists-view-main', [
      el('h1', 'Appointment that you are looking for does not exists'),
      el('p', [
        el('span', 'Please click '),
        el('a', { href: '/community' }, 'here'),
        el('span', ' to visit our community page.')
      ])
    ]);

  }

}

export default ActivityNotExistsView;